module.exports = __webpack_public_path__ + "img/mobilesystem4.3487e562.png";